import * as React from 'react';

function GooglePlayIcon(props) {
  return (
    <svg width={121} height={28} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M60.732 15.279c-2.51 0-4.497 1.877-4.497 4.483 0 2.503 1.987 4.484 4.497 4.484s4.496-1.877 4.496-4.484c0-2.71-1.986-4.483-4.496-4.483zm0 7.09c-1.36 0-2.51-1.147-2.51-2.71 0-1.565 1.15-2.712 2.51-2.712 1.36 0 2.51 1.043 2.51 2.711 0 1.564-1.15 2.711-2.51 2.711zm-9.726-7.09c-2.51 0-4.496 1.877-4.496 4.483 0 2.503 1.987 4.484 4.496 4.484 2.51 0 4.497-1.877 4.497-4.484 0-2.71-1.987-4.483-4.497-4.483zm0 7.09c-1.36 0-2.51-1.147-2.51-2.71 0-1.565 1.15-2.712 2.51-2.712 1.36 0 2.51 1.043 2.51 2.711 0 1.564-1.15 2.711-2.51 2.711zM39.4 16.634v1.877h4.496c-.104 1.043-.523 1.877-1.045 2.398-.628.626-1.674 1.356-3.451 1.356-2.824 0-4.915-2.19-4.915-5.005 0-2.816 2.196-5.005 4.915-5.005 1.464 0 2.614.625 3.45 1.355l1.36-1.355c-1.15-1.043-2.614-1.877-4.706-1.877-3.764 0-7.006 3.128-7.006 6.882 0 3.754 3.242 6.882 7.006 6.882 2.092 0 3.556-.626 4.81-1.981 1.255-1.252 1.674-3.024 1.674-4.38 0-.417 0-.834-.105-1.147H39.4zm47.476 1.46c-.418-1.043-1.464-2.815-3.764-2.815-2.301 0-4.183 1.772-4.183 4.483 0 2.503 1.882 4.484 4.392 4.484 1.987 0 3.242-1.251 3.66-1.981l-1.464-1.043c-.523.73-1.15 1.252-2.196 1.252-1.046 0-1.673-.418-2.196-1.356l5.96-2.503-.209-.52zm-6.065 1.46c0-1.668 1.36-2.607 2.3-2.607.733 0 1.465.417 1.674.939l-3.974 1.668zm-4.915 4.275h1.987V10.795h-1.987v13.034zm-3.137-7.612c-.523-.521-1.36-1.043-2.405-1.043-2.197 0-4.288 1.982-4.288 4.484 0 2.503 1.987 4.38 4.288 4.38 1.045 0 1.882-.522 2.3-1.043h.105v.625c0 1.669-.941 2.607-2.405 2.607-1.15 0-1.987-.834-2.197-1.564l-1.673.73C67.006 26.54 68.261 28 70.457 28c2.3 0 4.183-1.356 4.183-4.588v-7.925h-1.882v.73zm-2.3 6.152c-1.36 0-2.51-1.147-2.51-2.71 0-1.565 1.15-2.712 2.51-2.712 1.359 0 2.404 1.147 2.404 2.711 0 1.564-1.045 2.711-2.405 2.711zm25.515-11.574h-4.706v13.034h1.987v-4.9h2.72c2.195 0 4.287-1.565 4.287-4.067 0-2.503-2.092-4.067-4.288-4.067zm.105 6.256h-2.824v-4.483h2.824c1.464 0 2.3 1.25 2.3 2.19-.104 1.146-.94 2.293-2.3 2.293zm12.026-1.877c-1.464 0-2.928.626-3.451 1.982l1.778.73c.418-.73 1.045-.939 1.777-.939 1.046 0 1.987.626 2.092 1.668v.105c-.314-.209-1.15-.522-1.987-.522-1.882 0-3.765 1.043-3.765 2.92 0 1.773 1.569 2.92 3.242 2.92 1.36 0 1.987-.626 2.51-1.252h.104v1.043h1.883v-5.005c-.209-2.294-1.987-3.65-4.183-3.65zm-.209 7.195c-.628 0-1.569-.313-1.569-1.147 0-1.043 1.15-1.355 2.092-1.355.836 0 1.254.208 1.777.417-.209 1.251-1.255 2.085-2.3 2.085zm10.98-6.882l-2.196 5.63h-.105l-2.3-5.63h-2.092l3.451 7.925-1.987 4.38h1.987l5.333-12.305h-2.091zm-17.568 8.342h1.986V10.795h-1.986v13.034z'
        fill='#fff'
      />
      <path
        d='M.418.368C.105.68 0 1.202 0 1.828v23.044c0 .625.21 1.147.523 1.46l.104.104 12.968-12.93v-.209L.418.367z'
        fill='url(#prefix__paint0_linear_5216_46282)'
      />
      <path
        d='M17.777 17.886l-4.287-4.275v-.313l4.287-4.275.105.104 5.124 2.92c1.464.834 1.464 2.19 0 3.024l-5.229 2.815z'
        fill='url(#prefix__paint1_linear_5216_46282)'
      />
      <path
        d='M17.882 17.782l-4.392-4.38L.418 26.436c.523.522 1.255.522 2.196.105l15.268-8.76z'
        fill='url(#prefix__paint2_linear_5216_46282)'
      />
      <path
        d='M17.882 9.023L2.614.368C1.673-.153.941-.049.418.472l13.072 12.93 4.392-4.38z'
        fill='url(#prefix__paint3_linear_5216_46282)'
      />
      <path
        opacity={0.2}
        d='M17.777 17.677l-15.163 8.55c-.836.522-1.568.418-2.091 0l-.105.105.105.104c.523.417 1.255.521 2.091 0l15.163-8.759z'
        fill='#191919'
      />
      <path
        opacity={0.12}
        d='M.418 26.228C.105 25.915 0 25.394 0 24.768v.104c0 .626.21 1.147.523 1.46v-.104H.418zm22.588-11.47l-5.228 2.92.104.104 5.124-2.92c.732-.417 1.046-.938 1.046-1.46 0 .522-.418.939-1.046 1.356z'
        fill='#191919'
      />
      <path
        opacity={0.25}
        d='M2.614.472l20.392 11.574c.628.417 1.046.835 1.046 1.356 0-.521-.314-1.043-1.046-1.46L2.614.368C1.15-.466 0 .159 0 1.828v.104C0 .368 1.15-.362 2.614.472z'
        fill='#fff'
      />
      <path
        d='M67.976 3.826c-.127-1.03-.923-1.621-1.977-1.621-1.203 0-2.12.83-2.12 2.289 0 1.453.902 2.289 2.12 2.289 1.168 0 1.873-.76 1.977-1.58l-.974-.004c-.091.476-.474.75-.987.75-.692 0-1.16-.502-1.16-1.455 0-.927.462-1.456 1.167-1.456.527 0 .907.298.98.788h.974zM72.047 6.722h1.194l-1.859-2.39 1.777-2.066H71.96l-1.511 1.78h-.194v-1.78h-.963v4.456h.963v-1.9h.33l1.462 1.9zM75.136 6.722l.338-1.016h1.643l.338 1.016h1.032l-1.57-4.456h-1.24l-1.572 4.456h1.031zm.583-1.752l.56-1.686h.036l.56 1.686h-1.156zM79.846 2.266v1.436c-.003 1.014.706 1.457 1.805 1.457.229 0 .63-.03.905-.084v1.647h.94V2.266h-.94v2.062a5.685 5.685 0 01-.905.079c-.605 0-.87-.19-.87-.705V2.266h-.936zM85.86 6.722l.337-1.016h1.643l.338 1.016h1.032l-1.57-4.456H86.4l-1.572 4.456h1.031zm.582-1.752l.56-1.686h.036l.56 1.686h-1.156zM89.648 3.042h1.394v3.68h.952v-3.68h1.394v-.776h-3.74v.776zM95.608 3.913V2.266h-.96v4.456h1.7c1.081 0 1.755-.581 1.753-1.423.002-.845-.672-1.386-1.752-1.386h-.74zm0 .744h.74c.519 0 .801.278.799.633.002.366-.28.675-.798.675h-.74V4.657zM101.568 6.722h1.946c1.023 0 1.567-.522 1.567-1.232 0-.66-.482-1.057-1-1.081v-.044c.473-.104.822-.433.822-.957 0-.668-.507-1.142-1.511-1.142h-1.824v4.456zm.963-.77V4.768h.807c.463 0 .749.26.749.629 0 .335-.233.554-.771.554h-.785zm0-1.822V3.027h.732c.426 0 .669.216.669.538 0 .352-.294.565-.687.565h-.714z'
        fill='#fff'
      />
      <defs>
        <linearGradient
          id='prefix__paint0_linear_5216_46282'
          x1={12.34}
          y1={1.629}
          x2={-5.16}
          y2={19.179}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00A0FF' />
          <stop offset={0.007} stopColor='#00A1FF' />
          <stop offset={0.26} stopColor='#00BEFF' />
          <stop offset={0.512} stopColor='#00D2FF' />
          <stop offset={0.76} stopColor='#00DFFF' />
          <stop offset={1} stopColor='#00E3FF' />
        </linearGradient>
        <linearGradient
          id='prefix__paint1_linear_5216_46282'
          x1={24.924}
          y1={13.403}
          x2={-0.38}
          y2={13.403}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FFE000' />
          <stop offset={0.409} stopColor='#FFBD00' />
          <stop offset={0.775} stopColor='orange' />
          <stop offset={1} stopColor='#FF9C00' />
        </linearGradient>
        <linearGradient
          id='prefix__paint2_linear_5216_46282'
          x1={15.505}
          y1={15.796}
          x2={-8.225}
          y2={39.595}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#FF3A44' />
          <stop offset={1} stopColor='#C31162' />
        </linearGradient>
        <linearGradient
          id='prefix__paint3_linear_5216_46282'
          x1={-2.827}
          y1={-7.269}
          x2={7.77}
          y2={3.359}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#32A071' />
          <stop offset={0.069} stopColor='#2DA771' />
          <stop offset={0.476} stopColor='#15CF74' />
          <stop offset={0.801} stopColor='#06E775' />
          <stop offset={1} stopColor='#00F076' />
        </linearGradient>
      </defs>
    </svg>
  );
}

export default GooglePlayIcon;
